import classnames from 'classnames';
import React, { FC } from 'react';
import { RouterLocation } from '@funtech-int/rival';
import { useRouter } from '@funtech-int/rival-react';

import { Button } from '@/shared/components/Button/Button';
import { Text } from '@/shared/components/Text';

import styles from './EmptyContent.module.css';

interface Props {
    title: string;
    disclaimer?: string;
    buttonText: string;
    location: RouterLocation<any, any>;
    iconSrc?: string;
    iconAlt?: string;
    className?: string;
}

export const EmptyContent: FC<Props> = ({
    title,
    disclaimer,
    location,
    buttonText,
    iconSrc,
    iconAlt,
    className,
}) => {
    const router = useRouter();

    const handleClick = () => {
        router.navigate({ to: location });
    };

    return (
        <div className={classnames(styles.root, className)}>
            {iconSrc && iconAlt && <img src={iconSrc} className={styles.icon} alt={iconAlt} />}
            <Text className={styles.text} viewVariant="centered">
                {title}
                {disclaimer && <div className={styles.disclaimer}>{disclaimer}</div>}
            </Text>
            <Button
                theme="dark"
                size={52}
                variant="accent"
                role="presentation"
                onClick={handleClick}
            >
                {buttonText}
            </Button>
        </div>
    );
};
